export default __webpack_public_path__ + "static/media/folder-open.28a5516b.svg";